import {
  getAuditDetails,
  getAuditFieldInfo,
  AuditService,
  AuditActionType,
} from 'shared/userAudit/audit-constants';
import { Operation, AuditDetails } from 'data/types';
import { CertStatus } from 'data/certStatus/certStatus.types';

// eslint-disable-next-line import/prefer-default-export
export function getCertStatusAuditDetailsToSubmit(
  certStatusServerData: CertStatus,
  originalCertStatusFormData: CertStatus | null,
  actionType: AuditActionType = AuditActionType.CERTSTATUS_ADD,
  isAuditEnabled: boolean,
  userId: string,
  userName: string,
  operation: Operation,
): AuditDetails {
  const auditDetails = getAuditDetails(
    isAuditEnabled,
    userId,
    userName,
    getAuditFieldInfo(certStatusServerData, null, operation === 'UPDATE', originalCertStatusFormData),
    certStatusServerData.id,
    AuditService.CERTSTATUS,
    actionType,
  );
  return auditDetails as AuditDetails;
}
